<template>
  <div class="p-4 bg-white/5 rounded-xl backdrop-blur flex flex-wrap gap-4 items-end">
    <!-- Date range selector (start / end) -->
    <DxDateBox v-model:value="startDate" display-format="yyyy-MM-dd" />
    <span>to</span>
    <DxDateBox v-model:value="endDate" display-format="yyyy-MM-dd" />

    <!-- Operator selector -->
    <DxSelectBox
      :items="operatorOptions"
      display-expr="operatorName"
      value-expr="operatorId"
      v-model:value="selectedOperator"
      placeholder="Select Operator"
      :disabled="operatorOptions.length === 0"
      class="min-w-[160px]"
    />

    <!-- Chemical selector -->
    <DxSelectBox
      :items="chemicalOptions"
      v-model:value="selectedChemical"
      placeholder="Select Chemical"
      :disabled="!selectedOperator || chemicalOptions.length === 0"
      class="min-w-[160px]"
    />

    <!-- Product selector (legacy) -->
    <DxSelectBox
      :data-source="products"
      value-expr="id"
      display-expr="name"
      placeholder="Product"
      v-model:value="productId"
      :search-enabled="true"
      class="min-w-[160px]"
    />

    <!-- Location selector (legacy) -->
    <DxSelectBox
      :data-source="locations"
      value-expr="id"
      display-expr="name"
      placeholder="Location"
      v-model:value="locationId"
      :search-enabled="true"
      class="min-w-[160px]"
    />

    <!-- Apply button -->
    <DxButton text="Apply" type="default" @click="applyFilters" />
  </div>
</template>

<script setup>
/* global defineEmits */
import DxDateBox   from 'devextreme-vue/date-box';
import DxSelectBox  from 'devextreme-vue/select-box';
import DxButton    from 'devextreme-vue/button';

import { ref, computed, watch } from 'vue';

import filtersState, {
  operators as operatorOptions,
  chemicals  as chemicalOptions,
  setOperator,
  setChemical,
} from './temp-data-and-supports/useForecastFilters.js';

const emit = defineEmits(['filter-change', 'filters-change']);

// --- date range & other legacy filters (kept for now) ---
const startDate  = ref(new Date(2025, 0, 1));
const endDate    = ref(new Date());
const productId  = ref(null);
const locationId = ref(null);

const products = [
  { id: 1, name: 'Gasoline' },
  { id: 2, name: 'Diesel' },
  { id: 3, name: 'Oil' },
];

const locations = [
  { id: 1, name: 'Calgary' },
  { id: 2, name: 'Edmonton' },
  { id: 3, name: 'Red Deer' },
];

// --- operator / chemical selections bound to composable ---
const selectedOperator = computed({
  get: () => filtersState.operatorId,
  set: val => setOperator(val),
});

const selectedChemical = computed({
  get: () => filtersState.chemical,
  set: val => setChemical(val),
});

// Emit combined payload once both selections are made
watch(
  () => [filtersState.operatorId, filtersState.chemical],
  ([op, chem]) => {
    if (op && chem) {
      emit('filters-change', { operatorId: op, chemical: chem });
    }
  }
);

function applyFilters() {
  emit('filter-change', {
    dateRange: [startDate.value, endDate.value],
    productId: productId.value,
    locationId: locationId.value,
  });
}
</script>
